/* global axios */
import ApiClient from './ApiClient';

class ProviderTeamsAPI extends ApiClient {
  constructor() {
    super('provider_team', { accountScoped: true });
  }

  getTeam(providerId = null) {
    return axios.get(this.url, {
      params: providerId ? { provider_id: providerId } : {},
    });
  }

  inviteMember({ name, email, providerId = null }) {
    return axios.post(this.url, {
      name,
      email,
      ...(providerId ? { provider_id: providerId } : {}),
    });
  }

  updateMember(memberId, active, providerId = null) {
    return axios.patch(`${this.url}/members/${memberId}`, {
      active,
      ...(providerId ? { provider_id: providerId } : {}),
    });
  }

  removeMember(memberId, providerId = null) {
    return axios.delete(`${this.url}/members/${memberId}`, {
      params: providerId ? { provider_id: providerId } : {},
    });
  }
}

export default new ProviderTeamsAPI();
